import React from "react";

interface Props {
  location: {
    latitude: number;
    longitude: number;
  };
}

const LocationImageView: React.FC<Props> = ({ location }) => {
  const handleClick = () => {
    const googleMapsUrl = `https://www.google.com/maps?q=${location.latitude},${location.longitude}`;
    window.open(googleMapsUrl, "_blank");
  };

  return (
    <div style={styles.container} onClick={handleClick}>
      <img
        style={styles.image}
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${location.latitude},${location.longitude}&zoom=15&size=800x800&markers=color:red%7Clabel:V%7C${location.latitude},${location.longitude}&key=AIzaSyAiTuYmyTJPsCamgRJ8Tbz0GuiMce8R8OQ`}
        alt="Visit location"
      />
      <div style={styles.overlay}>
        <span style={styles.overlayText}>View on Google Maps</span>
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: "relative" as "relative",
    display: "inline-block",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
    transition: "transform 0.2s ease-in-out",
  },
  image: {
    width: "100%",
    height: "auto",
    display: "block",
    transition: "opacity 0.3s ease-in-out",
  },
  overlay: {
    position: "absolute" as "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    opacity: 0,
    transition: "opacity 0.3s ease-in-out",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  overlayText: {
    color: "white",
    fontSize: "18px",
    fontWeight: "bold",
  },
  containerHover: {
    transform: "scale(1.05)",
  },
  overlayHover: {
    opacity: 1,
  },
};

export default LocationImageView;
